import Cookie from 'js-cookie';
import { LocationUtilities, SiteUtilities, ResponsiveUtilities } from '../utils';
import GA4Utilities from '../utils/ga4-utilities';
import fchatFormHandlers from './fchat-form-handlers';
import fdeskFormHandlers from './fdesk-form-handlers';

const fwcssuiteSignupFormSuccess = function ($form, response, alohaV2 = false, spamResponse = false) {
  const email = $form.find('.email-form').val();
  const emailHash = SiteUtilities.getShaHash(email);
  const geoLocation = LocationUtilities.getGeoLocation();
  const redirect = SiteUtilities.trimAndremoveTrailingSlash($form.attr('data-redirect'));
  const redirectSpam = SiteUtilities.trimAndremoveTrailingSlash($form.attr('data-redirect-spam'));
  const isExternalIframeSignup = $form.parents('.external-iframe-signup').length;
  const currentReferrer = SiteUtilities.getCurrentReferrer();

  SiteUtilities.configureAssetId($form, 'fwcssuite');

  let redirectUrl = '#';
  let spamScore = 0;
  let accountId = '';
  if (alohaV2) {
    const signupResponse = response['product_signup_response'];
    redirectUrl = signupResponse['redirect_url'].replace(/\/$/, '');
    accountId = (signupResponse.account && signupResponse.account.id) ? signupResponse.account.id : null;
  } else {
    if (spamResponse) {
      const spamResponseBody = JSON.parse(spamResponse[0].body);
      spamScore = spamResponseBody.Results['RISK SCORE'];
      accountId = response[0].account_id;
      redirectUrl = response[0].url;
    } else {
      redirectUrl = response.url;
      spamScore = 0;
      accountId = response.account_id;
    }
  }

  // Storing growsumo data
  const gsdata = {
    first_name: $form.find('.first-name-form').val(),
    email_id: $form.find('.email-form').val(),
    domain: $form.find('.domain-form').val() || null,
    account_id: 'fdesk.' + accountId
  };
  localStorage.setItem('gsdata', JSON.stringify(gsdata));

  // Post to freshmarketer.
  // Construct freshmarketer object for api submission only on 200 status code
  const freshmarketerData = {
    freshmarketerObject: {
      first_name: $form.find('.first-name-form').val(),
      last_name: $form.find('.last-name-form').val(),
      email: email,
      phone: $form.find('.phone-form').val() || '',
      company: $form.find('.company-form').val(),
      country: geoLocation ? geoLocation.countryName : '',
      contactable: ($form.find('input[name="send_promotions"]').is(':checked')),
      custom_field: {
        cf_fdesklastreferrer: Cookie.get('fw_flu') || '',
        cf_fdesksignupreferrer: window.location.href || '',
        cf_signupdevice: ResponsiveUtilities.getDeviceType(),
        cf_freshmarketer_list: $form.find('.fm-list-id').val(),
        cf_department: $form.find('.department-form').val() || '',
        cf_joblevel: $form.find('.job-level-form').val() || ''
      },
      domainUrl: redirectUrl,
      product: 'Freshworks Customer Service Suite',
      accountId: accountId,
      composite_stitching_key: response.composite_stitching_key || null
    }
  };

  const isBusinessEmail = SiteUtilities.isBusinessEmail(email);
  if (!isBusinessEmail) {
    freshmarketerData.freshmarketerObject.custom_field['cf_leadspaceindustry'] = $form.find('.company-industry-form').val() || '';
    freshmarketerData.freshmarketerObject.custom_field['cf_website'] = $form.find('.website-form').val() || '';
  }

  GA4Utilities.ga4ThankYouEvent(accountId, redirectUrl, $form);
  SiteUtilities.passSignupResponseToGA(accountId, redirectUrl, 'Freshworks Customer Service Suite');

  // Code to add a param to the thank-you page for referral program sign-ups
  const utmSource = SiteUtilities.getParameterByName('utm_source');
  let referralParam = '';
  if (utmSource && utmSource === 'invitereferrals') {
    referralParam = `&referral_sign_up=${encodeURIComponent('true')}&email=${encodeURIComponent($form.find('.email-form').val())}&username=${encodeURIComponent(($form.find('.first-name-form').val()) + ($form.find('.last-name-form').val()))}`;
  }

  const planName = SiteUtilities.getParameterByName('plan');
  // Storing the redirect url locally to avoid XSS from url.
  redirectUrl = (planName && planName !== '') ? redirectUrl + '?plan=' + planName : redirectUrl;

  const redirectUrlEncode = encodeURIComponent(redirectUrl);
  let thankYouRedirect = (spamScore < 5) ? `${redirect}/?redirect=${redirectUrlEncode}${referralParam}&aid=${accountId}&ehash=${emailHash}` : `${redirectSpam}/?redirect=${redirectUrlEncode}${referralParam}&aid=${accountId}&ehash=${emailHash}`;
  if (isExternalIframeSignup) {
    thankYouRedirect += '&post_to_partner=true';
    if (currentReferrer) {
      thankYouRedirect += `&first_referrer=${encodeURIComponent(currentReferrer)}`;
    }
  }

  const leadCapture = () => {
    const growSumoPayload = SiteUtilities.buildGrowSumoPayload('pk_ZUb1nXFPs1riXIiwEozmL4trdtiWngWL', '');
    const collectorPayload = SiteUtilities.freshmarketerPost(freshmarketerData, false, $form, false);
    const admitadPayload = SiteUtilities.buildAdmitadPayload(growSumoPayload.customer_key);
    localStorage.setItem('fmarketerStartTime', new Date().toISOString());
    jQuery.when(
      SiteUtilities.postToKinesis({ growSumoPost: growSumoPayload, fmCollectorPost: collectorPayload, admitadPost: admitadPayload })
    ).catch(function (e) {
      SiteUtilities.log(
        'Error in Freshmarketer or GrowSumo Post API Call',
        'error',
        'fwcssuite-form-handlers.js',
        1,
        e
      );
    }).always(function () {
      localStorage.setItem('fmarketerEndTime', new Date().toISOString());
      localStorage.removeItem('gsdata');
      SiteUtilities.triggersignupPerformanceLogApi(true);
      SiteUtilities.signupToProductRedirect(redirectUrl, isExternalIframeSignup);
    });
    // Make historyPushState an asynchronous operation to ensure that the upcoming SignupLog function can still access /signup as the page URL.
    SiteUtilities.historyPushState(thankYouRedirect, true);
  };
  leadCapture();
};

const fwcssuiteLoginForm = function (classname, form) {
  const $form = $(form);
  const subdomain = $form.find('.subdomain-product').val();
  if (subdomain === '.myfreshworks.com') {
    fchatFormHandlers.fchatLoginForm(classname, form);
  } else if (subdomain === '.freshdesk.com') {
    fdeskFormHandlers.fdeskLoginForm(classname, form);
  }
};

const fwcssuiteForgotDomainForm = function (classname, form) {
  const $form = $(form);
  const email = $form.find('.email-form').val();
  const forgotDomainUrl = $form.data('forgot-domain-url') || 'https://web.freshchat.com/app/organisation/list?email=';
  if (!email) return;
  const btnElement = $form.find('.button');
  $form.find('.button').addClass('button--loading').attr('disabled', 'disabled');

  const errorHandler = () => {
    btnElement.removeClass('button--loading').removeAttr('disabled');
    $form.find('.email-form').parents('.form-field').addClass('error');
    $form.find('.error-wrapper').empty().append("<em class='error'>This email does not exist</em>");
  };

  $.ajax({
    url: forgotDomainUrl + encodeURIComponent(email) + '&product=cxsuite',
    type: 'GET',
    success: (response) => {
      if (!response) return errorHandler();
      btnElement.removeClass('button--loading').removeAttr('disabled');
      jQuery('.form-wrapper', '.forgot-domain-form-wrapper').slideUp(300);
      setTimeout(function () {
        jQuery('.forgot-domain-success').slideDown(300);
      }, 300);
    },
    error: (xhr, status, err) => errorHandler()
  });
};

export default {
  fwcssuiteSignupFormSuccess,
  fwcssuiteLoginForm,
  fwcssuiteForgotDomainForm
};
